import request from '../../utils/request';
import requestFormData from '../../utils/requestFormData';

export function createCompany(params) {
  // FormData needs the .get() method to fetch values

  return requestFormData(`/companies`, {
    method: 'POST',
    data: params,
  });
}

export function getCompanies(params) {
  return request(`/companies`, {
    method: 'GET',
    params,
  });
}

export function getPartnerCompanies(params) {
  return request(`/companies/partners`, {
    method: 'GET',
    params,
  });
}

export function getCompany(params) {
  const { id } = params;
  return request(`/companies/${id}`, {
    method: 'GET',
  });
}

export function getPartnerCompany(params) {
  const { id } = params;
  return request(`/companies/partners/${id}`, {
    method: 'GET',
  });
}

export function updateCompany(params) {
  // FormData needs the .get() method to fetch values
  const id = params.get('id');
  params.delete('id');

  return requestFormData(`/companies/${id}`, {
    method: 'PATCH',
    data: params,
  });
}
